<template>
  <td :class="[`cell-value-${col}`]">
    <div v-if="preview && isImage(preview)">
      <img
        :src="preview"
        class="datagrid__upload__thumbnail"
      >
    </div>
    <div v-else>
      {{ entry[col] }}
    </div>
  </td>
</template>

<script>
export default {
  props: {
    entry: Object,
    col: String,
  },
  data() {
    return {
      preview: null,
    };
  },
  created() {
    if (this.entry[this.col]) {
      this.generatePreview();
    }
  },
  methods: {
    isImage(value) {
      return value.indexOf('.png') !== -1 || value.indexOf('.jpg') !== -1;
    },
    generatePreview() {
      this.$http
        .get('/filesystem/getSignedUrl', {
          params: {
            object: this.entry[this.col],
          },
        })
        .then(response => {
          this.preview = response.data;
        });
    },
  },
};
</script>

<style>
.datagrid__upload__thumbnail {
  max-width: 75px;
  max-height: 75px;
}
</style>
